@file:OptIn(InternalResourceApi::class)

package portalvv.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/portalvv.shared.generated.resources/"

@delegate:ResourceContentHash(-598_458_457)
internal val Res.font.inter_bold: FontResource by lazy {
      FontResource("font:inter_bold", setOf(
        ResourceItem(setOf(), "${MD}font/inter_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_364_818_641)
internal val Res.font.inter_medium: FontResource by lazy {
      FontResource("font:inter_medium", setOf(
        ResourceItem(setOf(), "${MD}font/inter_medium.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(89_588_670)
internal val Res.font.inter_regular: FontResource by lazy {
      FontResource("font:inter_regular", setOf(
        ResourceItem(setOf(), "${MD}font/inter_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(374_067_956)
internal val Res.font.inter_semibold: FontResource by lazy {
      FontResource("font:inter_semibold", setOf(
        ResourceItem(setOf(), "${MD}font/inter_semibold.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("inter_bold", Res.font.inter_bold)
  map.put("inter_medium", Res.font.inter_medium)
  map.put("inter_regular", Res.font.inter_regular)
  map.put("inter_semibold", Res.font.inter_semibold)
}
